<template>
    <div>

        <v-tooltip top color="primary" v-for="filter in filtersDefined"
                   :key="filter.type">

            <template v-slot:activator="{ on }">

                <v-chip v-on="on"
                        color="grey darken-2"
                        close
                        pill
                        :active="filter.model"
                        @click:close="remove(filter)"

                >
                    <v-avatar left class="primary">
                        <v-icon color="white" small>mdi-filter</v-icon>
                    </v-avatar>

                    <div v-if="filter.clickable" @click="activeClicked(filter)">
                        {{filter.type === 'segment' ? filter.custom.name : filter.name}}
                        {{getSelectedOptionName(filter)}}
                    </div>
                    <div v-else>
                        {{filter.type === 'segment' ? filter.custom.name : filter.name}}
                    </div>

                    <!-- FILTER OPTION SELECTION -->
                    <v-dialog
                            v-if="filter.menu"
                            v-model="filter.dialog"
                            max-width="300px">

                        <v-toolbar dense>
                            <v-toolbar-title>Select time period</v-toolbar-title>
                            <v-spacer></v-spacer>

                            <v-btn icon text @click="filter.dialog=false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card>
                            <v-list>

                                <v-list-item
                                        v-for="option in filter.menu.options"
                                        :key="option.type"
                                        @click="menuOptionSelected(filter,option)"
                                >
                                    <v-list-item-avatar>
                                        <v-icon v-if="filter.model && option.model">mdi-check</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        {{option.name}}
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-dialog>

                </v-chip>
            </template>

            <span>{{filter.name}} -filter active!</span>

        </v-tooltip>

        <!-- FILTER SELECTION MENU -->
        <v-menu offset-y v-if="filtersAvailable">
            <template v-slot:activator="{ on }">
                <v-chip v-on="on" pill>
                    <v-avatar left color="primary">
                        <v-icon>mdi-plus</v-icon>
                    </v-avatar>
                    Add filter
                </v-chip>
            </template>

            <v-list>
                <v-subheader>
                    Available filter(s)
                </v-subheader>
                <template v-for="(item, index) in filtersDefined">

                    <v-list-item @click="add(item)" v-show="!item.model">

                        <v-list-item-action>
                            <v-icon v-if="item.icon">{{item.icon}}</v-icon>
                        </v-list-item-action>

                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="item.description">
                                {{ item.description }}
                            </v-list-item-subtitle>
                        </v-list-item-content>

                    </v-list-item>

                    <v-divider v-if="filtersDefined.length -1 > index" :key="index"></v-divider>

                </template>
            </v-list>

        </v-menu>

        <!-- SAMPLE DEFINITION BUILDER DIALOG -->
        <v-dialog
                v-model="builderDialogOpenModel"
                fullscreen
                hide-overlay
                transition="fade-transition"
        >
            <v-card v-if="builderDialogOpenModel" color="grey darken-4">
                <v-card-text>

                    <segment-builder
                            @cancel="cancelDefinition"
                            @save="saveDefinition"
                            :form="false"
                            :show-business-rules="false"
                            saveButtonText="Filter"
                            :json_query="jsonQuery"
                            :json_filter="jsonFilter"
                    ></segment-builder>

                </v-card-text>
            </v-card>

        </v-dialog>

        <!-- PICK SEGMENT DIALOG -->
        <segment-picker-dialog
                v-model="segmentPickerModel"
                filters-only
                @select="segmentSelected"
                @close="segmentPickerModel=false"
        ></segment-picker-dialog>

    </div>
</template>

<script>

    import SegmentBuilder from '../../modules/Segments/components/SegmentBuilder';
    import SegmentPickerDialog from './SegmentPickerDialog';

    export default {

        components: {
            SegmentBuilder,
            SegmentPickerDialog
        },

        props: {

            /** Array of filters **/
            filters: {
                type: Array,
                required: true
            },

            /** If true only one filter can be active at one time **/
            exclusive: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {
                filterMenuModel: false,
                filtersDefined: [],

                jsonQuery: null,
                jsonFilter: null,

                builderDialogOpenModel: false,
                segmentPickerModel: false,
            }
        },

        computed: {
            filterName() {
                if (this.filter.custom) {
                    return this.filter.custom.name;
                } else {
                    return this.filter.name;
                }
            },
            filtersAvailable() {
                if (this.exclusive) {
                    return this.filters.filter(filter => filter.model).length === 0;
                }
                return this.filters.filter(filter => !filter.model).length > 0;
            }
        },

        methods: {
            add(filter) {
                if (filter.menu) {
                    filter.dialog = true;
                } else if (filter.type === 'queryFilter') {
                    filter.custom.jsonQuery = null;
                    filter.custom.jsonFilter = null;
                    this.builderDialogOpenModel = true;
                } else if (filter.type === 'segment') {
                    this.segmentPickerModel = true;
                } else {
                    filter.model = true;
                    this.emit();
                }
            },

            activeClicked(filter) {
                // Multi select menu
                if (filter.menu) {
                    filter.dialog = true;
                }
                // Query builder
                else if (filter.type === 'queryFilter') {
                    this.builderDialogOpenModel = true;
                    this.jsonQuery = filter.custom.jsonQuery;
                    this.jsonFilter = filter.custom.jsonFilter;
                } else if (filter.type === 'segment') {
                    this.jsonQuery = filter.custom.jsonQuery;
                    this.jsonFilter = filter.custom.jsonFilter;
                    this.builderDialogOpenModel = true;
                }
                // Plain canned filter
                else {
                    this.$emit('click', Object.assign({}, filter))
                }
            },

            menuOptionSelected(filter, option) {
                // Select and deselect everything else
                filter.menu.options.forEach(o => {
                    if (o.value === option.value) o.model = true; else o.model = false;
                });
                filter.model = true;
                filter.dialog = false;
                this.emit();
            },

            getSelectedOptionName(filter) {
                if (filter.menu) {
                    const option = filter.menu.options.find(option => option.model);
                    return option ? ' - ' + option.name : null;
                }
                return null;
            },

            saveDefinition(definition) {
                let filter = this.filtersDefined.find(filter => filter.type === 'queryFilter');
                filter.custom.jsonQuery = definition.json_query;
                filter.custom.jsonFilter = definition.json_filter;
                filter.model = true;
                this.builderDialogOpenModel = false;
                this.emit();
            },

            segmentSelected(segment) {
                let filter = this.filtersDefined.find(filter => filter.type === 'segment');
                filter.custom.jsonQuery = segment.json_query;
                filter.custom.jsonFilter = segment.json_filter;
                if (segment.name.length > 30) {
                    filter.custom.name = segment.name.substring(0, 30) + '...';
                } else {
                    filter.custom.name = segment.name;
                }
                filter.model = true;
                this.segmentPickerModel = false;
                this.emit();
            },

            cancelDefinition() {
                this.builderDialogOpenModel = false;
            },

            remove(filter) {
                filter.model = false;
                this.emit();
            },

            emit() {
                console.log(this.filtersDefined);
                this.$emit('change', JSON.parse(JSON.stringify(this.filtersDefined)));
            },
        },

        mounted() {
            this.filtersDefined = JSON.parse(JSON.stringify(this.filters));
        },

    }
</script>
